import React, { useEffect, useState } from 'react'
import { Modal, Button, FormGroup, FormControl, Label } from 'react-bootstrap'

import i18n from 'live/services/i18n'

import { AbsoluteLoading, RoundedModal } from '../../../../../generic'
import { AssetType } from '../../../../../utils/services/assetType'
import { CreateEditAssetTypeModalContainer } from './styles'

interface IProps {
    show: boolean
    setShow: (k: boolean) => void
    type: 'create' | 'edit'
    handleClose: () => void
    assetType?: AssetType
    setOperation?: (k: AssetType) => void
    handleCreate?: (k: string) => Promise<void>
    handleUpdate?: (k: AssetType) => Promise<void>
}

export const CreateEditAssetTypeModal: React.FC<IProps> = ({
    show,
    setShow,
    type,
    handleClose,
    assetType,
    handleCreate,
    handleUpdate,
    setOperation
}) => {
    const [assetTypeName, setAssetTypeName] = useState<string>('')

    const onSave = async (): Promise<void> => {
        if (type === 'create') {
            await handleCreate(assetTypeName)
        } else {
            const updatedAssetType: AssetType = { id: assetType.id, name: assetTypeName }

            await handleUpdate(updatedAssetType)
        }

        setAssetTypeName('')
        handleClose()
    }

    const onClose = (): void => {
        setAssetTypeName('')
        handleClose()
    }

    const openProtocol = (): void => {
        if (type === 'edit') {
            setAssetTypeName(assetType?.name)
        }
    }

    useEffect(() => {
        openProtocol()
    }, [assetType])

    return (
        <CreateEditAssetTypeModalContainer>
            <RoundedModal show={show} onHide={onClose} aria-labelledby="contained-modal-title">
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title">
                        {type === 'create' ? i18n('New Resource Type') : i18n('Edit Resource Type')}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <FormGroup>
                        <span style={{ fontSize: 13, fontWeight: 600 }}>{i18n('Resource Type name')}</span>
                        <FormControl
                            type={'text'}
                            onChange={e => {
                                setAssetTypeName((e.target as HTMLInputElement).value)
                            }}
                            className={'modal-input'}
                            value={assetTypeName}
                            maxLength={50}
                        />
                        <span style={{ fontSize: 12, fontWeight: 400, color: 'var(--gray-700)' }}>
                            {i18n('The name is used to identify the resource type.')}
                        </span>
                    </FormGroup>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        className="no-outline-button"
                        bsStyle="primary"
                        onClick={onSave}
                        style={{ borderRadius: 3, marginRight: 8 }}
                        id="diagramList-list-button-newDiagram"
                        disabled={!assetTypeName || assetTypeName.length === 0}
                    >
                        {i18n('Save')}
                    </Button>
                    <Button
                        className="no-outline-button"
                        onClick={onClose}
                        style={{ borderRadius: 3, marginRight: 8 }}
                        id="diagramList-list-button-newDiagram"
                    >
                        {i18n('Close')}
                    </Button>
                </Modal.Footer>
            </RoundedModal>
        </CreateEditAssetTypeModalContainer>
    )
}
